import React from 'react';
import { Drawer } from '@mui/material';
import GuestRow from './GuestRow';
import { IconChevronLeft } from '@tabler/icons-react';
import { TripInvite } from '../../../gql/graphql';

interface ManageGuestsDrawerProps {
  open: boolean;
  onClose: () => void;
  guests: TripInvite[];
  numberOfGuests: number;
  bookingId: number;
  tripId: number;
}

const ManageGuestsDrawer: React.FC<ManageGuestsDrawerProps> = ({
  open,
  onClose,
  guests,
  numberOfGuests,
  bookingId,
  tripId,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: '100%', // Make the drawer full width
            maxWidth: '100%', // Ensure it doesn't exceed full width
            height: '100%', // Make the drawer full height
            maxHeight: '100%', // Ensure it doesn't exceed full height
          },
        },
      }}
    >
      <div className="p-6">
        <button
          type="button"
          onClick={onClose}
          aria-label="Back to trip details"
          className="flex items-center"
        >
          <IconChevronLeft size={24} />
        </button>
        <div className="flex flex-col mt-6">
          <span className="text-2xl font-semibold text-neutral-800">
            Guests details
          </span>
          <span className="text-neutral-500">
            Add guests, rental gears, and airport transfer details
          </span>
        </div>
        {Array.from({ length: numberOfGuests }, (_, index) => {
          const guest = guests[index];

          return (
            <GuestRow
              key={index}
              guest={guest}
              guestNumber={index + 1}
              bookingId={bookingId}
              tripId={tripId}
            />
          );
        })}
      </div>
    </Drawer>
  );
};

export default ManageGuestsDrawer;
